import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerService } from './logger.service';
import { DeviceDetectorModule, DeviceDetectorService } from 'ngx-device-detector';

@NgModule({
  imports: [
    CommonModule,
    DeviceDetectorModule
  ],
  declarations: [],
  providers: [LoggerService, DeviceDetectorService]
})
export class LoggerModule { }



// WEBPACK FOOTER //
// ./src/app/logger/logger.module.ts